<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PA5"></a><a id="GBS.PA5.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA5.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA5.w.0.1.0"></a></div><div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PA5.w.0.2.0"></a><a id="GBS.PA5.w.0.2.0.1"></a></div>
<div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PP2"></a>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA1"></a>
<a id="GBS.PA5.w.0.3.0"></a><img alt="Image for page 2" src="data/content-0002.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA5.w.0.3.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA3"></a>
<a id="GBS.PA5.w.0.4.0"></a><img alt="Image for page 4" src="data/content-0003.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA5.w.0.4.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA4"></a>
<a id="GBS.PA5.w.0.5.0"></a><img alt="Image for page 5" src="data/content-0004.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA5.w.0.5.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PA5"></a>
<div class="gtxt_body" id="block.6.0.0.box.402.589.1400.817.q.60">
<a id="ORIG-GBS.PA5.w.0.0.0"></a><p class="gtxt_body" id="para.6.0.0.box.402.589.865.58.q.60">“You cannot teach a crab to walk straight.”</p>
<a id="ORIG-GBS.PA5.w.0.1.0"></a><p class="gtxt_body" id="para.6.0.1.box.1530.643.271.58.q.80" style="text-align:right;">Aristophanes</p>
<a id="ORIG-GBS.PA5.w.0.2.0"></a><p class="gtxt_body" id="para.6.0.2.box.402.751.389.59.q.60">“Thank goodness.”</p>
<a id="ORIG-GBS.PA5.w.0.3.0"></a><p class="gtxt_body" id="para.6.0.3.box.1542.806.260.58.q.70" style="text-align:right;">Judy Colbert</p>
<a id="ORIG-GBS.PA5.w.0.4.0"></a><p class="gtxt_body" id="para.6.0.4.box.402.914.211.46.q.70">Thanks to:</p>
<a id="ORIG-GBS.PA5.w.0.5.0"></a><p class="gtxt_body" id="para.6.0.5.box.402.981.1400.160.q.60" style="text-indent:1em;">Each and every person who contributed a recipe, an idea, a photograph, a concept, and knowledge about the Chesapeake Bay, its watermen, and its blue crabs.</p>
<a id="ORIG-GBS.PA5.w.0.6.0"></a><p class="gtxt_body" id="para.6.0.6.box.402.1143.1400.167.q.50" style="text-indent:1em;"><a id="GBS.PA5.w.0.6.0"></a>Joyce A. Stinnett Baki, Calvert County Department of Economic Development, and Aubrey Manzo, Southern Delaware Tourism, who gave so much time and provided so much assistance.</p>
<a id="ORIG-GBS.PA5.w.0.7.0"></a><p class="gtxt_body" id="para.6.0.7.box.402.1306.1400.100.q.60" style="text-indent:1em;"><a id="GBS.PA5.w.0.7.0"></a><a id="GBS.PA6"></a><a id="GBS.PA6.w.0.0.0"></a><a id="GBS.PA7"></a><a id="GBS.PA7.w.0.0.0"></a><a id="GBS.PA7.w.1.0.0"></a><a id="GBS.PA7.w.1.1.0"></a><a id="GBS.PA7.w.1.2.0"></a>Jack Brooks at J. M. <a id="GBS.PA7.w.1.3.0"></a><a id="GBS.PA7.w.1.4.0"></a><a id="GBS.PA7.w.1.5.0"></a><a id="GBS.PA7.w.1.6.0"></a>Clayton Co. and Mike <a id="GBS.PA7.w.1.7.0"></a><a id="GBS.PA7.w.1.8.0"></a><a id="GBS.PA7.w.1.9.0"></a><a id="GBS.PA7.w.1.10.0"></a><a id="GBS.PA7.w.1.11.0"></a><a id="GBS.PA7.w.1.12.0"></a><a id="GBS.PA7.w.1.13.0"></a><a id="GBS.PA7.w.1.14.0"></a><a id="GBS.PA7.w.1.15.0"></a><a id="GBS.PA7.w.1.16.0"></a>and Don Storm at Shor<a id="GBS.PA7.w.1.17.0"></a><a id="GBS.PA7.w.1.18.0"></a><a id="GBS.PA7.w.1.19.0"></a><a id="GBS.PA7.w.1.20.0"></a><a id="GBS.PA7.w.1.21.0"></a><a id="GBS.PA7.w.1.22.0"></a><a id="GBS.PA7.w.1.23.0"></a>eline Seafood.</p><a id="GBS.PA8"></a><a id="GBS.PA8.w.0.0.0"></a><a id="GBS.PA9"></a><a id="GBS.PA9.w.0.0.0"></a>
</div><a id="GBS.PA10"></a><a id="GBS.PA10.w.0.0.0"></a>
</div><div style="display:none;"><a id="GBS.PA11"></a><a id="GBS.PA11.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA11.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA11.w.0.0.0.2"></a></div><div class="flow" style="">
</div>
<div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PA7"></a>
</div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA9"></a>
<a id="GBS.PA11.w.0.0.0.3"></a><img alt="Image for page 10" src="data/content-0005.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA11.w.0.0.0.4"></a></div>
<div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PA11.w.0.0.0.5"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0006.vue?9cd99cba